module.exports = __webpack_public_path__ + "img/icon_box_3_2.8fae8cbb.png";